import WebinarsServiceDetail from "./WebinarsServiceDetail";

export default WebinarsServiceDetail;
